import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Modal, Loader } from 'wix-style-react'
import * as _ from 'lodash'

import Menu from './instaTagPosts/Menu'
import Posts from './instaTagPosts/Posts'
import { fetchInstagramImages } from 'controllers/integrations'
import { setCustomFieldArray } from 'controllers/logic'
import { removeFromStorage } from 'controllers/storage'
import TagProducts from './instaTagPosts/TagProducts'
import { media } from 'components/styles'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #eff4f7;
  display: flex;
  justify-content: center;
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 18px;`}
`

const Container = styled.div`
  width: 100%;
  max-width: 1500px;
  min-width: 1200px;
  height: 100%;
  margin-left: 3%;
  margin-right: 3%;
  display: flex;
  flex-direction: column;
`
const LoaderContainer = styled.div`
  margin-top: 3em;
  align-self: center;
`
const TagProductsContainer = styled.div`
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 18px;`}
`

const POSTS_LIMIT = 100
const POSTS_PER_PAGE = 15

class InstaTagPosts extends Component {

  constructor (props) {
    super(props)
    const posts = this.getShowcases(props.app)
    this.state = {
      editablePostIndex: -1,
      posts: posts,
      initializing: true,
      filteredPosts: posts,
      activePage: 1
    }
    this.postsRaw = {}
    this.filterVisability = 0
    this.searchString = ''
  }

  componentWillReceiveProps (nextProps) {
    const posts = this.getShowcases(nextProps.app)
    const filteredPosts = this.filterPosts(posts)
    this.setState({
      posts,
      filteredPosts
    })
  }

  componentWillMount () {
    const { app } = this.props
    const showcases = this.getShowcases(app)
    if (showcases.length === 0) {
      const instaName = this.getInstaName(app)
      if (instaName) this.fetchPosts(instaName, this.onPostsReceived(instaName))
    } else {
      this.setState({initializing: false})
    }
  }

  componentWillUnmount () {
    this.onPostReceived = () => null
    this.onPostsUpdateReceived = () => null
  }

  postRawToModel = (p, instaName) => {
    return {
      id: p.id,
      image: p.images.thumbnail.url,
      imageMedium: p.images.low_resolution.url,
      imageStandard: p.images.standard_resolution.url,
      instaName,
      createdTime: p.created_time,
      caption: _.get(p, ['caption', 'text'], null),
      products: null
    }
  }

  saveDefaultPosts = (instaName, postsRaw) => {
    // console.log('saveDefaultPosts', postsRaw)
    const posts = _.map(postsRaw, p => this.postRawToModel(p, instaName))
    const sortedPosts = _.sortBy(posts, ['created_time'])
    const { dispatch, app } = this.props
    dispatch(setCustomFieldArray(app.id, ['showcases'], sortedPosts))
    this.setState({initializing: false})
  }

  onPostsReceived = instaName => {
    return (data) => {
      // console.log('onPostsReceived', data)
      if (data.status === 'ok') {
        const currentPosts = _.get(this.postsRaw, instaName, [])
        const newPosts = currentPosts.concat(data.items)
        this.postsRaw[instaName] = newPosts
        if (data.more_available && _.size(newPosts) < POSTS_LIMIT) {
          const maxId = data.items[data.items.length - 1].id
          this.fetchPosts(instaName, this.onPostsReceived(instaName), maxId)
        } else {
          this.saveDefaultPosts(instaName, newPosts)
        }
      }
    }
  }

  fetchPosts (instaName, callback, maxId = null) {
    const { dispatch } = this.props
    // console.log('init', maxId)
    // console.log('init, instaName', instaName)
    dispatch(fetchInstagramImages(instaName, maxId, callback))
  }

  onPostsUpdateReceived = instaName => {
    return (data) => {
      // console.log('onPostsUpdateReceived', data)
      if (data.status === 'ok') {
        const { app, dispatch } = this.props
        const newRawPosts = _.takeWhile(data.items, p => this.postIndexById(p.id) === -1)
        const newPosts = _.map(newRawPosts, p => this.postRawToModel(p, instaName))
        // console.log('newPosts', newPosts)
        const postsCopy = _.clone(this.state.posts)
        const posts = newPosts.concat(postsCopy)
        // console.log('posts now', posts)
        dispatch(setCustomFieldArray(app.id, ['showcases'], posts))
      }

      this.setState({initializing: false})
    }
  }

  onGetNewPosts = () => {
    console.log('onGetNewPosts')
    const { app } = this.props
    const { posts } = this.state
    if (posts.length > 0) {
      const instaName = this.getInstaName(app)
      this.setState({initializing: true})
      if (instaName) this.fetchPosts(instaName, this.onPostsUpdateReceived(instaName))
    }
  }


  onTagProducts = (post) => {
    // console.log('onTagProducts', post, index)
    const index = this.postIndexById(post.id)
    this.setState({
      editablePostIndex: index
    })
  }

  onCloseTagProducts = () => {
    this.setState({
      editablePostIndex: -1
    })
  }

  getShowcases = (app) => _.get(app, ['customFields', 'showcases'], [])
  getInstaName = (app) => _.get(app, ['customFields', 'appSettings', 'instaName'])
  getProductsDict = (app) => _.get(app, ['customFields', 'productsDict'], {})
  getShopifyConnected = (app) => _.has(app, ['customFields', 'appSettings', 'integration', 'accessToken'])

  updatePost = (postIndex) => {
    return (newData) => {
      const { dispatch, app } = this.props
      dispatch(setCustomFieldArray(app.id, ['showcases', postIndex], newData))
    }
  }

  onDeleteProduct = (productId) => {
    const { app, dispatch } = this.props
    const productsDict = this.getProductsDict(app)
    const product = productsDict[productId]
    if (product) {
      const showcases = _.clone(this.getShowcases(app))
      for (const post of showcases) {
        const postProducts = _.get(post, 'products', [])
        _.remove(postProducts, p => p.info.productId === productId)
      }
      dispatch(setCustomFieldArray(app.id, ['showcases'], showcases))
      dispatch(setCustomFieldArray(app.id, ['productsDict', productId], null))
      for (const asset of product.assets) {
        dispatch(removeFromStorage(app.id, asset.id))
      }
    }
  }

  renderTagProductsModal () {
    const { editablePostIndex, posts } = this.state
    const { app } = this.props
    const shopifyConnected = this.getShopifyConnected(app)
    const productsDict = this.getProductsDict(app)
    // console.log('app', app)
    if (editablePostIndex > -1) {
      const post = posts[editablePostIndex]
      if (post) {
        return (
          <Modal
            isOpen={editablePostIndex > -1}
            contentLabel='Tag products modal'
          >
            <TagProductsContainer>
              <TagProducts
                appId={app.id}
                shopifyConnected={shopifyConnected}
                post={post}
                postIndex={editablePostIndex}
                onClose={this.onCloseTagProducts}
                updatePost={this.updatePost(editablePostIndex)}
                productsDict={productsDict}
                onDeleteProduct={this.onDeleteProduct}
              />
            </TagProductsContainer>
          </Modal>
        )
      }
    }
  }

  postIndexById (postId) {
    const { posts } = this.state
    return _.findIndex(posts, p => p.id === postId)
  }

  onChangePostVisible = (post) => {
    return () => {
      const { app, dispatch } = this.props
      const i = this.postIndexById(post.id)
      const value = post.disabled ? null : true
      dispatch(setCustomFieldArray(app.id, ['showcases', i, 'disabled'], value))
    }
  }

  filterPosts (posts) {
    const res = []
    for (const post of posts) {
      let visabilityOk = true
      if (this.filterVisability === 1 && post.disabled) visabilityOk = false
      if (this.filterVisability === 2 && !post.disabled) visabilityOk = false

      let searchOk = true
      if (this.searchString !== '') searchOk = post.caption && post.caption.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1

      if (visabilityOk && searchOk) res.push(post)
    }
    return res
  }

  renderPosts () {
    const { initializing, filteredPosts, activePage } = this.state
    const { app } = this.props
    const productsDict = this.getProductsDict(app)
    if (initializing) {
      return (
        <LoaderContainer>
          <Loader text='Loading...' />
        </LoaderContainer>
      )
    } else {
      const posts = _.slice(filteredPosts, POSTS_PER_PAGE * (activePage - 1), POSTS_PER_PAGE * activePage)
      return (
        <Posts
          productsDict={productsDict}
          posts={posts}
          onTagProducts={this.onTagProducts}
          onChangePostVisible={this.onChangePostVisible}
        />
      )
    }
  }

  updateFilteredPosts = () => {
    this.setState({
      filteredPosts: this.filterPosts(this.state.posts),
      activePage: 1
    })
  }

  onSearchStringChange = (v) => {
    this.searchString = v
    this.updateFilteredPosts()
  }

  onChangeFilterVisability = (v) => {
    this.filterVisability = v
    this.updateFilteredPosts()
  }

  renderMenu () {
    const { app } = this.props
    const { filteredPosts, activePage } = this.state
    return (
      <Menu
        app={app}
        filterVisability={this.filterVisability}
        onChangeFilterVisability={this.onChangeFilterVisability}
        searchString={this.searchString}
        onSearchStringChange={this.onSearchStringChange}
        pagActivePage={activePage}
        pagItemsCountPerPage={POSTS_PER_PAGE}
        pagItemsCount={filteredPosts.length}
        pagOnPaginationChange={pageNum => this.setState({activePage: pageNum})}
        onGetNewPosts={this.onGetNewPosts}
      />
    )
  }

  render () {
    return (
      <Wrapper>
        <Container>
          {this.renderMenu()}
          {this.renderPosts()}
        </Container>
        {this.renderTagProductsModal()}
      </Wrapper>
    )
  }
}

InstaTagPosts.propTypes = {
  app: PropTypes.object.isRequired
}


export default connect()(InstaTagPosts)



// WEBPACK FOOTER //
// ./src/components/editor/insta/InstaTagPosts.js